import { useCallback } from "react";
import { Navigate, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useInactivityTimeout } from "../../hooks/useInactivityTimeout";
import { SessionTimeoutWarning } from "../SessionTimeoutWarning/SessionTimeoutWarning";

export function ProtectedRoute({ children }) {
  const { authToken, logout } = useAuth();
  const navigate = useNavigate();

  const handleTimeout = useCallback(() => {
    logout();
    navigate("/login?reason=inactivity", { replace: true });
  }, [logout, navigate]);

  const { showWarning, remainingMs, extendSession } =
    useInactivityTimeout(handleTimeout);

  if (!authToken) {
    // Encode the full attempted path+search so nothing is lost.
    // LoginPage already reads qParams.get("next") — no changes needed there.
    return <Navigate to={`/login`} replace />;
  }

  // Layout-route: no children prop → render nested routes via <Outlet>
  return (
    <>
      {children ?? <Outlet />}
      <SessionTimeoutWarning
        open={showWarning}
        remainingMs={remainingMs}
        onExtend={extendSession}
        onLogout={handleTimeout}
      />
    </>
  );
}
